import { useNavigate } from "react-router-dom"
import { useAppSelector } from "../../../lib/redux/hooks"
import { Layout } from "../../../ui/layout"
import { ButtonComponent } from "../../../ui/molecules/button/newButton"
import { Banner } from "../../../ui/organisms/banner"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import { GestioneBiosuisseList } from "./listBiosuisse"

export function GestioneBiosuisse() {
    const navigate = useNavigate()
    const sessionState = useAppSelector(state => state.session)


    if (sessionState.selected.customerId) {
        return (
            <Layout menuItem={MenuItems.GESTIONE_CLIENTI} breadcrumbItems={['Gestione Clienti', 'Gestione Biosuisse']}
                noPaddingLat
                headerLabel="Gestione Biosuisse"
                headerChildren={
                    <div className="flex items-center h-full w-full justify-end">
                        <ButtonComponent size={"sm"} iconPosition={"off"} variant={"solid"} label="Crea nuovo" color={"orange"}
                            onClick={() => {
                                navigate('/addCertificazioneBiosuisse')
                            }}
                        />
                    </div>
                }
            >

                <div className="flex flex-col min-w-0 p-6">
                    <GestioneBiosuisseList />
                    {/* <div className="pb-5">
                        <ClientBanner
                            region={sessionState.selected.customerRegion!}
                            client={sessionState.selected.customerName!}
                            code={sessionState.selected.customerCode!}
                            activity={sessionState.selected.customerActivities ? `${sessionState.selected.customerActivities.map(act => optionsFormatter(act, attivita_bio))}` : undefined}
                            norm={optionsFormatter(sessionState.selected.customerNorm!, normativa)!}
                        />
                    </div> */}
                </div>
            </Layout>
        )
    }

    return (
        <Layout
            menuItem={MenuItems.GESTIONE_CLIENTI}
            breadcrumbItems={['Gestione Clienti', 'Gestione Biosuisse']}
            noPaddingLat
            headerLabel={"Gestione Biosuisse"}
            customerName={sessionState.selected.customerName ? sessionState.selected.customerName : undefined}
            customerCode={sessionState.selected.customerCode ? sessionState.selected.customerCode : undefined}
        >
            <Banner
                type="error"
                visible={!sessionState.selected.customerId}
                label={"Devi prima selezionare un cliente per accedere all'area"}
                closeAction={function (): void {
                    alert("Devi prima selezionare un cliente per accedere all'area")
                }}
            />
        </Layout>
    )
}